module.exports = __webpack_public_path__ + "img/wstage.a09e0bfb.jpg";